/* Find Your Ironclad: quiz UI. Screens 0-3, session state (never the email), submit sequence 4.2. */
(function () {
  'use strict';
  function onReady(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  onReady(function () {
    var root = document.querySelector('[data-icq-quiz]');
    var cfgEl = document.getElementById('icq-config');
    if (!root || !cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var C = window.ICQCore, T = window.ICQTrack;
    if (!C) return;

    var SS_KEY = 'icq:v1';
    var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid'];
    var PROG_WIDTHS = ['0%', '33%', '66%', '100%'];
    var PROG_LABELS = ['', '1 / 2', '2 / 2', 'Last step'];
    var AUTO_ADVANCE_MS = 250, MIN_BUSY_MS = 900, MAX_TOTAL_MS = 4000;

    var state = loadState() || {
      step: 1, q1: null, q2: null, route: null, firstName: '',
      market: cfg.market || 'nz', started_at: new Date().toISOString(), utms: {}
    };
    if (!state.utms) state.utms = {};
    if (state.market !== cfg.market) state.market = cfg.market || state.market;
    /* CHANGE-05: which ad angle's headline this visitor saw (?a=). The headline nodes themselves are
       swapped by the inline script in the liquid before first paint; this only feeds tracking. */
    state.angle = C.angleFrom(location.search);

    function loadState() {
      try { return JSON.parse(sessionStorage.getItem(SS_KEY) || 'null'); } catch (e) { return null; }
    }
    function saveState() {
      try { sessionStorage.setItem(SS_KEY, JSON.stringify(state)); } catch (e) { /* private mode */ }
    }
    function readUtms() {
      var out = {}, pairs = location.search.replace(/^\?/, '').split('&');
      for (var i = 0; i < pairs.length; i++) {
        var kv = pairs[i].split('=');
        if (kv.length < 2) continue;
        var k;
        try { k = decodeURIComponent(kv[0].replace(/\+/g, '%20')); } catch (e) { k = kv[0]; }
        if (UTM_KEYS.indexOf(k) !== -1) {
          try { out[k] = decodeURIComponent(kv.slice(1).join('=').replace(/\+/g, '%20')); } catch (e) { out[k] = kv.slice(1).join('='); }
        }
      }
      return out;
    }
    /* First load only: capture attribution into session state. Never appended to the redirect. */
    var freshSession = !loadState();
    if (freshSession) state.utms = readUtms();

    function isGift() { return state.q1 === 'Gift'; }
    function $(sel) { return root.querySelector(sel); }
    function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    function baseProps() {
      var p = { quiz_version: 'fyi-v1', market: state.market, angle: state.angle };
      for (var k in state.utms) if (state.utms[k]) p[k] = state.utms[k];
      return p;
    }
    function track(name, props, opts) { if (T) T.posthog(name, props, opts); }
    /* All navigation goes through ICQTrack.navigate so previews can override it. */
    function nav(url) {
      if (T && typeof T.navigate === 'function') T.navigate(url);
      else location.assign(url);
    }

    /* ---------- steps ---------- */
    function showStep(n, opts) {
      opts = opts || {};
      $$('.icq-step').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-icq-step') === String(n)); });
      var bar = $('[data-icq-progress-bar]'), lab = $('[data-icq-progress-label]');
      if (bar) bar.style.width = PROG_WIDTHS[n] || '0%';
      if (lab) lab.textContent = PROG_LABELS[n] || '';
      state.step = n;
      saveState();
      var active = root.querySelector('.icq-step.is-active'), live = $('[data-icq-live]');
      if (active) {
        /* Screen 1 has an angle h1 above the question h2: focus the focusable heading (tabindex -1). */
        var h = active.querySelector('h2[tabindex], h1[tabindex]') || active.querySelector('h1, h2');
        if (h && !opts.skipFocus) { try { h.focus({ preventScroll: false }); } catch (e) { h.focus(); } }
        if (live && h) live.textContent = h.textContent;
      }
      if (n === 3) {
        renderChips();
        var ch = $('[data-icq-contact-heading]');
        if (ch) ch.textContent = isGift() ? "Where should Kate send the pick?" : 'Where should Kate send your pick?';
        var nameInput = $('#icq-name');
        if (nameInput && state.firstName) nameInput.value = state.firstName;
        track('ironclad_quiz_contact_viewed', Object.assign(baseProps(), { route: state.route }));
      }
      if (n === 2) renderQ2();
    }

    /* ---------- Q2 (self/gift variants) ---------- */
    function renderQ2() {
      var list = $('[data-icq-q2]');
      if (!list) return;
      var heading = $('[data-icq-q2-heading]');
      if (heading) heading.textContent = isGift() ? 'What matters most in their Ironclad?' : 'What matters most in your Ironclad?';
      list.innerHTML = '';
      var variant = C.ANSWERS.q2[isGift() ? 'gift' : 'self'];
      variant.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'icq-option' + (state.q2 === opt.value ? ' is-selected' : '');
        btn.setAttribute('data-value', opt.value);
        var wrap = document.createElement('div');
        var label = document.createElement('span');
        label.className = 'icq-option-label';
        label.textContent = opt.label;
        var helper = document.createElement('span');
        helper.className = 'icq-option-helper';
        helper.textContent = opt.helper;
        wrap.appendChild(label);
        wrap.appendChild(helper);
        btn.appendChild(wrap);
        btn.addEventListener('click', function () { answerQ2(opt, btn); });
        list.appendChild(btn);
      });
    }

    /* Select exactly one option: clear is-selected on siblings first (post-Back re-picks). */
    function selectOnly(btn) {
      var siblings = btn.parentNode.querySelectorAll('.icq-option');
      for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-selected');
      btn.classList.add('is-selected');
    }

    function answerQ1(opt, btn) {
      if (q1Advancing) return; /* double-tap guard during the auto-advance */
      q1Advancing = true;
      markStarted();
      state.q1 = opt.value;
      selectOnly(btn);
      track('ironclad_quiz_answered', Object.assign(baseProps(), {
        step: 1, question: 'using_ironclad', answer_label: opt.label, answer_value: opt.value
      }));
      if (T) T.shopify('ironclad_quiz_answered', { step: 1, question: 'using_ironclad', answer_label: opt.label, answer_value: opt.value });
      saveState();
      setTimeout(function () { q1Advancing = false; showStep(2); }, AUTO_ADVANCE_MS);
    }

    function answerQ2(opt, btn) {
      state.q2 = opt.value;
      selectOnly(btn);
      state.route = C.routeFor(state.q1, state.q2);
      track('ironclad_quiz_answered', Object.assign(baseProps(), {
        step: 2, question: 'price_sensitive', answer_label: opt.label, answer_value: opt.value
      }));
      if (T) T.shopify('ironclad_quiz_answered', { step: 2, question: 'price_sensitive', answer_label: opt.label, answer_value: opt.value });
      saveState();
      setTimeout(function () { showStep(3); }, AUTO_ADVANCE_MS);
    }

    /* ---------- contact chips ---------- */
    function renderChips() {
      var wrap = $('[data-icq-chips]');
      if (!wrap) return;
      wrap.innerHTML = '';
      var q1label = '';
      C.ANSWERS.q1.forEach(function (o) { if (o.value === state.q1) q1label = o.label; });
      var chips = [
        { label: isGift() ? 'GIFT' : q1label.toUpperCase(), step: 1 },
        { label: state.q2 === 'yes' ? 'BEST PRICE' : 'PASS IT DOWN', step: 2 }
      ];
      chips.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'icq-chip';
        b.textContent = c.label;
        b.addEventListener('click', function () { goBack(c.step); });
        wrap.appendChild(b);
      });
    }

    function goBack(toStep) {
      track('ironclad_quiz_back', Object.assign(baseProps(), { from_step: state.step }));
      if (toStep === 1) { /* revising Q1 invalidates Q2 */ state.q2 = null; state.route = null; }
      showStep(toStep);
    }

    /* ---------- wiring ---------- */
    $$('[data-icq-q1] .icq-option').forEach(function (btn) {
      var value = btn.getAttribute('data-value');
      var opt = null;
      C.ANSWERS.q1.forEach(function (o) { if (o.value === value) opt = o; });
      btn.addEventListener('click', function () { if (opt) answerQ1(opt, btn); });
    });
    $$('[data-icq-back]').forEach(function (btn) {
      btn.addEventListener('click', function () { goBack(state.step > 1 ? state.step - 1 : 1); });
    });
    /* Q1 is the landing screen: "started" = the first Q1 tap, once per page view. */
    var startedSent = false, q1Advancing = false;
    function markStarted() {
      if (startedSent) return;
      startedSent = true;
      track('ironclad_quiz_started', baseProps());
      if (T) T.shopify('ironclad_quiz_started', {});
    }

    /* ---------- submit (spec 4.2) ---------- */
    var form = $('[data-icq-form]');
    if (form) form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (form.dataset.icqBusy === '1') return;
      var nameInput = $('#icq-name'), emailInput = $('#icq-email');
      var firstName = (nameInput.value || '').trim();
      var email = (emailInput.value || '').trim();
      var errName = $('[data-icq-error="name"]'), errEmail = $('[data-icq-error="email"]');
      if (errName) errName.classList.remove('is-visible');
      if (errEmail) errEmail.classList.remove('is-visible');
      if (!firstName) {
        if (errName) errName.classList.add('is-visible');
        nameInput.focus();
        track('ironclad_quiz_validation_error', Object.assign(baseProps(), { field: 'name' }));
        return;
      }
      if (!C.isValidEmail(email)) {
        if (errEmail) errEmail.classList.add('is-visible');
        emailInput.focus();
        track('ironclad_quiz_validation_error', Object.assign(baseProps(), { field: 'email' }));
        return;
      }
      /* The email lives in locals only: never URL, never storage, never console. */
      state.firstName = firstName;
      state.route = C.routeFor(state.q1, state.q2);
      saveState();

      var submitBtn = $('[data-icq-submit]');
      var btnHtml = submitBtn.innerHTML;
      form.dataset.icqBusy = '1';
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="icq-spinner" aria-hidden="true"></span>PICKING YOUR PAN&hellip;';
      var t0 = Date.now();
      var honeypot = $('#icq-company');
      var pick = (cfg.picks && cfg.picks[state.route]) || null;

      function finish() {
        var elapsed = Date.now() - t0;
        var wait = Math.max(0, Math.min(MIN_BUSY_MS - elapsed, MAX_TOTAL_MS - elapsed));
        setTimeout(function () {
          if (pick && pick.url) {
            /* Apply the free-shipping code in the background (sets Shopify's discount cookie), then go
               straight to the result page. Never wait more than 2.5s on the code. */
            var dest = C.resultUrl(cfg.code || 'WELCOME', pick.url, state.route);
            var gone = false;
            var go = function () { if (!gone) { gone = true; nav(dest); } };
            setTimeout(go, 2500);
            try {
              fetch(C.discountPath(cfg.code || 'WELCOME'), { credentials: 'same-origin' }).then(go, go);
            } catch (e) { go(); }
          } else {
            form.dataset.icqBusy = '0';
            submitBtn.disabled = false;
            submitBtn.innerHTML = btnHtml;
          }
        }, wait);
      }

      if (honeypot && honeypot.value) { /* bot: fake success, send nothing */
        finish();
        return;
      }

      var completedAt = new Date().toISOString();
      var eventId = 'icq-lead-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8).padEnd(6, '0');
      var props = C.buildLeadProps({
        usingIronclad: state.q1,
        priceSensitive: state.q2,
        market: state.market,
        route: state.route,
        pickHandle: pick ? pick.handle : null,
        completedAt: completedAt,
        angle: state.angle,
        utms: state.utms
      });
      var eventProps = Object.assign(baseProps(), {
        route: state.route,
        pick_handle: pick ? pick.handle : null,
        event_id: eventId,
        quiz_angle: state.angle
      });

      /* Overall 4s cap across both awaited Klaviyo calls. */
      var deadline = t0 + MAX_TOTAL_MS;
      function remaining() { return Math.max(0, deadline - Date.now()); }

      var chain = T ? T.klaviyoProfile(email, firstName, props, cfg.companyId).then(function (res) {
        if (!res.ok) track('ironclad_quiz_klaviyo_error', Object.assign(baseProps(), { step: 'profiles', status: res.status }));
        /* Subscribe even when the profile upsert failed: never skip the subscription.
           On success the profile is up first so market + answers exist before the
           list add triggers the welcome flow. */
        return T.klaviyoSubscribe(email, firstName, props, cfg.listId, cfg.companyId).then(function (res2) {
          if (!res2.ok) track('ironclad_quiz_klaviyo_error', Object.assign(baseProps(), { step: 'subscriptions', status: res2.status }));
        });
      }) : Promise.resolve(null);

      chain = chain.catch(function () { /* already logged inside; never block the redirect */ });

      Promise.race([chain, sleep(remaining())]).then(function () {
        if (T) {
          T.klaviyoIdentify(email, firstName);
          T.klaviyoTrack('Completed Ironclad Quiz', Object.assign({}, props, { $event_id: eventId }));
          T.metaLead(cfg, email, firstName, state.route, eventId);
          T.shopify('ironclad_quiz_lead', {
            route: state.route, using_ironclad: state.q1, price_sensitive: state.q2,
            market: state.market, pick_handle: pick ? pick.handle : null, event_id: eventId
          });
          T.posthogIdentify(email.toLowerCase(), { email: email, first_name: firstName, market: state.market });
          T.posthog('ironclad_quiz_lead', Object.assign({}, eventProps, {
            $set: { quiz_route: state.route, UsingIronclad: state.q1, price_sensitive: state.q2, quiz_angle: state.angle }
          }), { transport: 'sendBeacon' });
        }
        finish();
      });
    });

    function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    /* ---------- init ---------- */
    /* ?start=1 is kept for old links; every entry now lands on Q1. */
    track('ironclad_quiz_viewed', Object.assign(baseProps(), { entry: 'q1_first', angle: state.angle }));
    if (state.step && state.step > 1 && state.q1) {
      showStep(Math.min(3, state.step)); /* refresh mid-quiz resumes */
    } else {
      showStep(1, { skipFocus: true });
    }
  });
})();
